import { TileGrid } from "./tile-grid";
import Skeleton from "@web-ui/components/Skeleton";
import type { Kpi } from "../use-kpis";
import { MetricTile } from "./metric-tile";

/** A row of KPI tiles; placeholders of the same shape while the numbers load (no jump when they land). */
export function KpiRow({ tiles, placeholders = 4, columns = 4 }: { tiles: Kpi[] | null; placeholders?: number; columns?: 2 | 3 | 4 }) {
  return (
    <TileGrid columns={columns}>
      {tiles ? tiles.map((k) => <MetricTile key={k.id} definition={k.definition} value={k.value} change={k.change} upIsGood={k.id !== "ended"} trend={k.trend} trendPartial={k.trendPartial} />)
        : Array.from({ length: placeholders }, (_, i) => <div key={i} className="stat" aria-hidden="true"><Skeleton lines={3} /></div>)}
    </TileGrid>
  );
}
